import { FaInfoCircle } from "react-icons/fa";
import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { CardInformative } from "@/pages/esus/ReterritorializationAcsDashboard/CardInformative";
import { CardOverlayTrigger } from "@/components/CardOverlayTrigger";

type Props = {
	totalMedicalAttendancesOnTime: number;
	totalMedicalAttendancesOutTime: number;
	totalMedicalAttendancesWithoutRiskClassification: number;
	percentageEvasions: number;
};

export function MedicalOfficeCards({
	totalMedicalAttendancesOnTime,
	totalMedicalAttendancesOutTime,
	totalMedicalAttendancesWithoutRiskClassification,
	percentageEvasions,
}: Props) {
	return (
		<Row className="px-0 py-2 bg-white justify-content-evenly rounded">
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Total de atendimentos até tempo limite"
					value={totalMedicalAttendancesOnTime.toLocaleString()}
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Total de atendimentos fora do tempo limite"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					value={totalMedicalAttendancesOutTime.toLocaleString()}
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Atendimentos sem classificação"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={totalMedicalAttendancesWithoutRiskClassification.toLocaleString()}
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
			<Col sm={12} md={4} lg={3} xxl={3} className="my-2">
				<CardInformative
					title="Evasões consultorio"
					classNameCard="border border-muted rounded p-2 m-2 bg-white h-100"
					classNameTitle="text-muted text-center"
					classNameValue="text-muted"
					value={`${percentageEvasions.toLocaleString()} %`}
					metaData={
						<CardOverlayTrigger
							header=""
							message=""
							icon={<FaInfoCircle className="text-muted" />}
						/>
					}
				/>
			</Col>
		</Row>
	);
}
